import { PATHS } from '@constants/routes';
import { oktaConfig } from '@modules/auth/constants';
import { toRelativeUrl, OktaAuth } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { FC, useEffect } from 'react';
import { AuthProps } from './Auth.types';

const Auth: FC<AuthProps> = ({ children }) => {
  const oktaAuth = new OktaAuth({
    ...oktaConfig,
    // Links to the documentation on why active session renewal is disabled
    // to prevent idle sessions from being kept alive
    // https://github.com/okta/okta-auth-js/tree/master?tab=readme-ov-file#autorenew-1
    // https://github.com/okta/okta-auth-js/blob/master/docs/autoRenew-notice.md
    tokenManager: {
      autoRenew: true,
    },
    services: {
      autoRenew: false,
      autoRemove: false,
    },
    storageManager: {
      token: {
        storageTypes: ['sessionStorage'],
      },
      cache: {
        storageTypes: ['sessionStorage'],
      },
      transaction: {
        storageTypes: ['sessionStorage'],
      },
    },
  });

  useEffect(() => {
    void startOktaService();

    return (): void => {
      void stopOktaService();
    };
  }, []);

  const startOktaService = async (): Promise<void> => {
    await oktaAuth.start();
  };

  const stopOktaService = async (): Promise<void> => {
    await oktaAuth.stop();
  };

  const restoreOriginalUri = async (_oktaAuth: any, originalUri: string | undefined): Promise<void> => {
    originalUri = originalUri ?? PATHS.ROOT;
    window.location.href = toRelativeUrl(originalUri, window.location.origin);
  };
  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  );
};

export default Auth;
